import { Contract, ContractDetails as TContractDetails, getContractsEndpoint } from 'cpfr-common';
import { getSimpleDataFetchSlice } from '@cp-shared-19/frontend-integration';
import { DefaultBusinessMarketApiErrorCode } from '@cp-shared-19/common-utilities';
import { CpDataApi } from '../../cp-xhr';

const { reducer, fetchData, updateData } = getSimpleDataFetchSlice<
    Array<Contract & TContractDetails>,
    DefaultBusinessMarketApiErrorCode
>({
    dataName: 'contracts',
    fetchCallback() {
        return CpDataApi.get(getContractsEndpoint()).then((response) => response.data);
    },
});

export default reducer;
export const updateContracts = updateData;
export const fetchContracts = fetchData;
